export default __webpack_public_path__ + "assets/pete.697c2ea4.png";